import { 
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input, OnInit, AfterViewInit, ViewChild, ElementRef, Inject
} from '@angular/core';

import { TranslatePipe } from '@app/translate/TranslatePipe';
import { ProvidersExcludedFromDuration } from '@shared/flight-segment-connection/entities/segment-types';
import { AirValidationSector, AirValidationFlightsSector } from '@app/entities/air-validation.response';
import { TripTypes } from '@app/entities/trip-types';
import { TravelDetailProvider } from '@shared/flight-itinerary/entities/travel-detail-provider';
import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { BusClassTypes } from '@buses/bus-results/entities/bus-type';
import { IS_BROWSER } from '@app/modules/core/tokens/app.tokens';
import { Price } from '@app/entities/price';
import { PassengerArrangement } from '@shared/base-search-bar/entities/passenger-arrangement';
import { FlightSectorAirValidationSector } from '@booking/entities/flight-sectors.models';

@Component({
  selector: 'app-bus-sectors',
  templateUrl: './bus-sectors.component.html',
  styleUrls: ['./bus-sectors.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BusSectorsComponent implements OnInit, AfterViewInit {

  @ViewChild('bodycontainer') public bodyContainer: ElementRef;
  @ViewChild('container') public container: ElementRef;

  @Input() isMobile: boolean;
  @Input() airValidationSector: AirValidationSector[];
  @Input() busClass: BusClassTypes;
  @Input() provider: string;
  @Input() travelType: TravelBookingType;
  @Input() sectorSelected: number;
  @Input() price: Price;
  @Input() passengerArrangement: PassengerArrangement[];
  @Input() conversionRate: number;
  @Input() productReference: number;

  public travelInfoProvider: TravelDetailProvider = TravelDetailProvider.BOOKING_FLIGHT;

  constructor(
    private translatePipe: TranslatePipe,
    @Inject(IS_BROWSER) public isBrowser: boolean) { }

  ngOnInit(): void {
    this.travelInfoProvider =
      this.travelType === TravelBookingType.BUSES ? TravelDetailProvider.BOOKING_BUSES : TravelDetailProvider.BOOKING_FLIGHT;
  }

  ngAfterViewInit(): void {
    if (this.isBrowser) {
      const positionSectorSelected = this.airValidationSector.findIndex(route => route.SectorNumber === this.sectorSelected);
      if (positionSectorSelected > -1) {
        this.scrollToPosition(this.bodyContainer.nativeElement.children[positionSectorSelected].offsetTop);
      }
    }
  }

  get isExcludedFromDuration(): boolean {
    return Object.values(
      ProvidersExcludedFromDuration).includes(
        this.provider as ProvidersExcludedFromDuration);
  }

  public hasScales(airValidationSector: AirValidationSector): boolean {
    return airValidationSector.Flights.length - 1 > 0;
  }

  public isScaleElement(airValidationSector: AirValidationSector, index: number): boolean {
    return index < airValidationSector.Flights.length - 1;
  }

  public showDivider(index: number): boolean {
    return (this.airValidationSector.length - 1) > index;
  }

  public busType(airValidationSector: AirValidationSector): string {
    return this.translatePipe.transform(
      `BUS_RESULTS_MODULE.ITINERARY_LIST_SECTION.${airValidationSector.SectorNumber === TripTypes.DEPARTURE ?
        'DEPARTURE_TRIP' : 'RETURN_TRIP'}`
    );
  }

  public busDepartureDate(airValidationSector: AirValidationSector): string {
    return airValidationSector.Flights[0].DepartureDate;
  }

  public busItem(sector: AirValidationSector, item: number): AirValidationFlightsSector {
    return sector.Flights[item];
  }

  public nextBusItem(sector: AirValidationSector, item: number): AirValidationFlightsSector {
    return sector.Flights[item + 1] || {} as AirValidationFlightsSector;
  }
  
  public scrollToPosition(top: number): void {
    this.bodyContainer.nativeElement.scrollTo({
      left: 0, top: top
    });
  }

  public isReturnHeader(route: AirValidationSector): boolean {
    return route.SectorNumber !== TripTypes.DEPARTURE;
  }

  public toggleTravelInfo(sector: FlightSectorAirValidationSector): void {
    sector.isExpanded = !sector.isExpanded;
  }
}
